import {
  MEDIA_LIST_ATTEMPT,
  MEDIA_LIST_SUCCESS,
  MEDIA_LIST_FAILED,
  //////////////
  MEDIA_DELETE_SUCCESS,
  MEDIA_DELETE_FAILED,
  //////////////
  MEDIA_NEW_SUCCESS,
  MEDIA_NEW_LOADING,
  MEDIA_NEW_FAILED,
  //////////////
  MEDIA_RESET_LIST,
  MEDIA_REORDER_ATTEMPT,
  MEDIA_REORDER_SUCCESS,
  MEDIA_REORDER_FAILED,
} from "../types/mediaTypes";

const INITIAL_STATE = {
  list: [],
  loading: false,
  error: "",

  progress: 0,
  success: "",
  loadingFile: false,
  error_update: "",
  reordering: false,
};

function media(state = INITIAL_STATE, action) {
  switch (action.type) {
    case MEDIA_LIST_ATTEMPT:
      return {
        ...state,
        loading: true,
      };

    case MEDIA_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data.list,
        error: "",
      };

    case MEDIA_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        list: [],
      };
    /////////////////////////////
    case MEDIA_DELETE_SUCCESS: {
      const deletedId = String(action.item.Id);
      const newState = state.list.filter(
        (item) => String(item.Id) !== deletedId
      );
      return {
        ...state,
        list: newState,
        error_update: "",
      };
    }

    case MEDIA_DELETE_FAILED:
      return {
        ...state,
        error_update: action.error,
      };
    /////////////////////////////////
    case MEDIA_NEW_LOADING:
      return {
        ...state,
        loadingFile: true,
        progress: action.progress,
        success: "",
        error: "",
      };
    case MEDIA_NEW_SUCCESS: {
      return {
        ...state,
        loadingFile: false,
        progress: 0,
        error: "",
        list: [...state.list, action.item],
      };
    }

    case MEDIA_NEW_FAILED:
      return {
        ...state,
        loadingFile: false,
        progress: 0,
        error: action.error,
        error_update: action.error,
        success: "",
      };
    ///////////////////////////////
    case MEDIA_RESET_LIST:
      return INITIAL_STATE;

    case MEDIA_REORDER_ATTEMPT:
      return {
        ...state,
        reordering: true,
        error_update: "",
      };

    case MEDIA_REORDER_SUCCESS:
      return {
        ...state,
        reordering: false,
        list: action.data.list,
        error_update: "",
      };

    case MEDIA_REORDER_FAILED:
      return {
        ...state,
        reordering: false,
        error_update: action.error,
      };

    default:
      return state;
  }
}
export default media;
